const formFields = [
  // {
  //   label: 'What is your age?',
  //   name: 'age',
  //   type: 'number'
  // },
  {
    label: 'Number of children',
    name: 'number_of_children',
    type: 'number'
  },
  {
    label: 'Years lived in the country',
    name: 'years_lived_in_country',
    type: 'number'
  },
  {
    label: 'Years worked in the country',
    name: 'years_worked',
    type: 'number'
  },
  {
    label: 'Gender',
    name: 'gender',
    type: 'radio',
    values: ['woman', 'man']
  }
];

export default formFields;



// WEBPACK FOOTER //
// ./src/data/formFields.js